import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import './AccessibilityButtons.css';

export default function AccessibilityButtons({ variant = 'default' }) {
    const { theme, highContrast, toggleTheme, toggleContrast } = useTheme();

    return (
        <div className={`accessibility-buttons ${variant}`}>
            <button
                onClick={toggleTheme}
                className="btn-accessibility"
                aria-label={`Mudar para modo ${theme === 'light' ? 'escuro' : 'claro'}`}
                title={`Modo ${theme === 'light' ? 'escuro' : 'claro'}`}
            >
                <i className={`bi ${theme === 'light' ? 'bi-moon-stars-fill' : 'bi-sun-fill'}`}></i>
            </button>
            <button
                onClick={toggleContrast}
                className="btn-accessibility"
                aria-label={`${highContrast ? 'Desativar' : 'Ativar'} alto contraste`}
                title="Alto contraste"
            >
                <i className="bi bi-circle-half"></i>
            </button>
        </div>
    );
}
